import React, { useEffect, useState } from 'react';
import { useIntl } from 'umi';
import { Modal, Button, Table, Dropdown, List } from 'tea-component';
import './index.scss';
import AutoResizeTextArea from '../AutoResizeTextArea';
import { IconKey, iconMap } from '../../../constant';
import COMMON from '@/pages/home/assets/svg/studio//opinions/common.svg';
import ADD from '@/pages/home/assets/svg/studio//opinions/add.svg';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';

type RecordType = {
  index: number;
  highlight: string;
  executive_summary: string;
  titleEn: string;
  titleCn: string;
  defaultHighlight: string;
};

const { draggable } = Table.addons;

const EditModal = (props: any) => {
  const {
    reportData,
    highlightCnMap,
    closeModal,
    handelCancel: propsHandleCancel,
    isVisible,
    data,
    handleSubmit: propsHandelSubmit,
    highlightsOptions,
    setClickAddHighlight,
    clickAddHighlight,
    ...restProps
  } = props || {};
  const { formatMessage, locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;

  const [records, setRecords] = useState<RecordType[]>([]);
  const [isSave, setIsSave] = useState(false);
  const [confirmDisable, setConfirmDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // 其中一个参数为空时，禁用确认按钮
    const hasOnlyEmptyRecords = records?.some(
      record => record.highlight?.trim() === '' || record.executive_summary?.trim() === ''
    );
    setConfirmDisable(hasOnlyEmptyRecords);
  }, [records]);


  useEffect(() => {
    setRecords(reportData);
  }, [reportData]);

  const handleDelete = (index: number) => {
    setRecords(records.filter(record => record.index !== index));
  };

  const handleHighlightChange = (recordIndex: number, selectedHighlight: string) => {
    const updatedRecords = records?.map((record: any) => 
      record.index === recordIndex ? 
        { ...record, 
          ['highlight']: selectedHighlight || '',
          ['titleEn']: selectedHighlight  || '',
          ['titleCn']: (highlightCnMap[record?.selectedHighlight]) || '' 

        } : record
    );
    setRecords(updatedRecords);
  };

  // 新增行数据
  const handleAddRow = () => {
    const newRow = {
      index: records.length,
      highlight: '',
      executive_summary: ''
    };
    setRecords([...records, newRow]);

    // 插入行后滚动到底部
    setTimeout(() => {
      const tableBody = document.querySelector('.dbh_studio_highlight_report_edit_modal_table .tea-table__body');
      if (tableBody) {
        tableBody.scrollTop = tableBody.scrollHeight;
      }
    }, 0);
  };


  // 提交
  const handleSubmit = () => {
    setLoading(true);
    const filteredRecords = records.map(({ index, titleEn, titleCn, defaultHighlight, ...rest }) => rest);
    propsHandelSubmit(filteredRecords)?.finally(() => {
      setLoading(false);
      setIsSave(true);
      setClickAddHighlight(false);
    });
  };

  const handelCancel = () => {
    propsHandleCancel?.(false);
    setRecords(reportData);
    setIsSave(false);
    setClickAddHighlight(false);
  };

  return (
    <Modal
      visible={isVisible}
      size={1000}
      caption={clickAddHighlight ? formatMessage({ id: 'dbh_studio_add_highlights_1' }) : formatMessage({ id: 'dbh_studio_edit_highlights' })}
      onClose={() => {
        closeModal();
        setRecords(reportData);
        handelCancel();
        setClickAddHighlight(false);
      }}
      {...(restProps || {})}
    >
      <Modal.Body>
        <div style={{ zIndex: 100, position: 'relative' }}>
          <Table
            className={"dbh_studio_highlight_report_edit_modal_table"}
            records={records}
            recordKey="index"
            columns={[
              {
                key: "highlight",
                width: '230px',
                header: formatMessage({ id: 'dbh_studio_highlights' }),
                render: (record) => (
                  <div>
                    <Dropdown
                      clickClose={true}
                      style={{ marginRight: 5 }}
                      button={
                        <div style={{ display: "flex" }}>
                          <img
                            src={iconMap[record.highlight as IconKey] || COMMON}
                            style={{ marginRight: !highlightCnMap[record?.highlight] ? '0px' : '10px' }}
                            className="dbh-highlights-modal-item-icon"
                          />
                          {highlightCnMap[record?.highlight] ? getLanguage(isEN, record?.highlight, highlightCnMap[record?.highlight]) : ''}
                        </div>
                      }
                      placement="bottom-start"
                    >
                      <List type="option" className="dbh-highlight-select-list">
                        <span className="dbh-highlight-select-options-header-title">{formatMessage({ id: 'dbh_studio_select_icon' })}</span>
                        {highlightsOptions.map((option: { titleEn: string; titleCn: string; value: string; }, index: number) => (
                          <List.Item
                            key={index}
                            className="dbh-highlight-select-options"
                            onClick={() => handleHighlightChange(record?.index, option?.value)}
                          >
                            <div className="dbh-highlight-select-options-item">
                              <img
                                src={iconMap[option.titleEn as IconKey] || COMMON}
                                className="dbh-highlight-select-options-item-icon"
                              />
                              {getLanguage(isEN, option.titleEn, option.titleCn)}
                            </div>
                          </List.Item>
                        ))}
                      </List>
                    </Dropdown>
                    {(!highlightCnMap[record?.highlight]) && <AutoResizeTextArea
                      placeholder={formatMessage({ id: 'dbh_studio_input_placeholder' })}
                      style={{ width: '139px' }}
                      index={record.index}
                      records={records}
                      recordKey={'highlight'}
                      setRecords={setRecords}
                      isSave={isSave}
                      value={String(highlightCnMap[record?.highlight] || record?.highlight || '')}
                      highlightCnMap={highlightCnMap}
                    />}
                  </div>
                ),
              },
              {
                key: "summary",
                width: '615px',
                header: formatMessage({ id: 'dbh_studio_summary' }),
                render: (record) => (
                  <AutoResizeTextArea
                    placeholder={formatMessage({ id: 'dbh_studio_input_placeholder' })}
                    index={record.index}
                    records={records}
                    recordKey={'executive_summary'}
                    setRecords={setRecords}
                    value={String(record.executive_summary)}
                    isSave={isSave}
                  />
                ),
              },
              {
                key: "actions",
                width: '89px',
                header: formatMessage({ id: 'dbh_studio_action' }),
                render: (record) => (
                  <span
                    className='dbh_studio_highlight_report_edit_modal_table_delete_btn'
                    onClick={() => handleDelete(record.index)}
                  >
                    {formatMessage({ id: 'Delete' })}
                  </span>
                ),
              },
            ]}
            addons={[
              draggable({
                onDragEnd: (newRecords) => {
                  setRecords(newRecords);
                },
              }),
            ]}
          />
          <div className="dbh-add-row-button-container" onClick={handleAddRow}>
            <img
              src={ADD}
              className="dbh-add-row-icon"
            />
            <span>{formatMessage({ id: 'dbh_studio_add_row' })}</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={confirmDisable}
          loading={loading}
        >
          {formatMessage({ id: 'dbh_studio_funcom_edit_modal_comfirm' })}
        </Button>
        <Button
          type="weak"
          onClick={handelCancel}
        >
          {formatMessage({ id: 'dbh_studio_funcom_edit_modal_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;